'use strict';

// Reserved keywords not allowed to use in the parser
module.exports = {
  end: true
};



//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/expression/keywords.js
// module id = 1190
// module chunks = 0